<template>

    <form action="#" method="POST" class="form-eli">

        <div class="row">
            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="rut">Rut</label>
                    <input type="text" name="rut" required class="form-control" v-model="form.rut" placeholder="Rut" maxlength="16" @blur="BuscarProfesorJornadaParcial()">
                    <p class="help-block" v-if="form.errors.has('rut')" v-text="form.errors.get('rut')"></p>
                </div>
            </div>
            <div class="col-md-8" v-if="this.msg">
                <p class="alert alert-info mb-0">{{ this.msg }}</p>
                <p class="mb-0"><small><b>Nota: </b> Si se registra un nuevo cargo, el cargo actual quedará inactivo</small></p>
            </div>
        </div>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="nombres">Nombres</label>
                    <input type="text" name="nombres" class="form-control" v-model="form.nombres" required placeholder="Nombres" maxlength="191">
                    <p class="help-block" v-if="form.errors.has('nombres')" v-text="form.errors.get('nombres')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="apellido_paterno">Apellido paterno</label>
                    <input type="text" required name="apellido_paterno" class="form-control" v-model="form.apellido_paterno" placeholder="Apellido paterno" maxlength="191">
                    <p class="help-block" v-if="form.errors.has('apellido_paterno')" v-text="form.errors.get('apellido_paterno')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="apellido_materno">Apellido materno</label>
                    <input type="text" name="apellido_materno" class="form-control" v-model="form.apellido_materno" placeholder="Apellido materno" maxlength="191">
                    <p class="help-block" v-if="form.errors.has('apellido_materno')" v-text="form.errors.get('apellido_materno')"></p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="fecha_nacimiento">Fecha de nacimiento</label>
                    <input type="date" name="fecha_nacimiento" class="form-control" v-model="form.fecha_nacimiento" placeholder="Fecha de nacimiento">
                    <p class="help-block" v-if="form.errors.has('fecha_nacimiento')" v-text="form.errors.get('fecha_nacimiento')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="nacionalidad_id">Nacionalidad</label>
                    <select name="nacionalidad_id" required id="nacionalidad_id" v-model="form.nacionalidad_id" class="form-control" placeholder="Seleccione nacionalidad">
                        <option v-for="nacionalidad in form_data.nacionalidades" :value="nacionalidad.id" :key="nacionalidad.codigo">{{ nacionalidad.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('nacionalidad_id')" v-text="form.errors.get('nacionalidad_id')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="genero_id">Género</label>
                    <select name="genero_id" required id="genero_id" v-model="form.genero_id" class="form-control" placeholder="Seleccione género">
                        <option v-for="genero in form_data.generos" :value="genero.id" :key="genero.id">{{ genero.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('genero_id')" v-text="form.errors.get('genero_id')"></p>
                </div>
            </div>

        </div>

        <hr>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="cargo_personal_id">Cargo</label>
                    <select name="cargo_personal_id" required id="cargo_personal_id" v-model="form.cargo_personal_id" class="form-control" placeholder="Seleccione cargo">
                        <option v-for="cargo_personal in form_data.cargos_personal" :value="cargo_personal.id" :key="cargo_personal.id">{{ cargo_personal.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('cargo_personal_id')" v-text="form.errors.get('cargo_personal_id')"></p>
                </div>

            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="area_estrategica_id">Área estratégica</label>
                    <select name="area_estrategica_id" required id="area_estrategica_id" v-model="form.area_estrategica_id" class="form-control" placeholder="Seleccione área estratégica">
                        <option v-for="area_estrategica in form_data.areas_estrategicas" :value="area_estrategica.id" :key="area_estrategica.id">{{ area_estrategica.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('area_estrategica_id')" v-text="form.errors.get('area_estrategica_id')"></p>
                </div>
            </div>

        </div>

        <hr>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="fecha_incorporacion">Fecha de incorporacion</label>
                    <input type="date" name="fecha_incorporacion" class="form-control" v-model="form.fecha_incorporacion" placeholder="Fecha de incorporacion">
                    <p class="help-block" v-if="form.errors.has('fecha_incorporacion')" v-text="form.errors.get('fecha_incorporacion')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="fecha_salida">Fecha de salida</label>
                    <input type="date" name="fecha_salida" class="form-control" v-model="form.fecha_salida" placeholder="Fecha de salida">
                    <p class="help-block" v-if="form.errors.has('fecha_salida')" v-text="form.errors.get('fecha_salida')"></p>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-8">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="observaciones">Observaciones</label>
                    <textarea name="observaciones" class="form-control" v-model="form.observaciones" placeholder="Observaciones" rows="5"></textarea>
                    <p class="help-block" v-if="form.errors.has('observaciones')" v-text="form.errors.get('observaciones')"></p>
                </div>
            </div>

            <div class="col-md-4" v-if="persona_id">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="estado_id">Estado</label>
                    <select name="estado_id" id="estado_id" class="form-control" v-model="form.estado_id">
                        <option v-for="estado in form_data.estados" :value="estado.id" :key="'estado-' + estado.id">{{ estado.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('observaciones')" v-text="form.errors.get('observaciones')"></p>
                </div>
            </div>
        </div>

        <div v-if="permite_crear_user">
            <hr>

            <h4>Cuenta de usuario (opcional)</h4>

            <div class="row">
                <div class="col-md-4">
                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" name="email" class="form-control" v-model="form.email" placeholder="E-mail" maxlength="191">
                        <p class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Form Submit -->
        <div class="form-group text-center">
            <button type="button" @click="onSubmit()" class="btn btn-eli">Guardar</button>
        </div>

    </form>

</template>

<script>
    export default {
        data() {
            return {
                form: new window.Form({
                    rut: '',
                    nombres: '',
                	apellido_paterno: '',
                    apellido_materno: '',
                    fecha_nacimiento: '',
                    nacionalidad_id: '',
                    genero_id: '',
                    cargo_personal_id: '',
                    area_estrategica_id: '',
                    fecha_incorporacion: '',
                    fecha_salida: '',
                    observaciones: '',
                    email: '',
                    estado_id: '',
                    _method: 'POST',
                }),
                form_data: {
                    areas_estrategicas: [],
                    estados: [],
                    generos: [],
                    nacionalidades: [],
                },
                profesor: null,
                cargo: null,
                msg: null,
            }
        },
        props: {
            permite_crear_user: {required: false, default: true},
            persona_id: {required: false, default: null},
        },
        mounted() {
            this.CargarAreasEstrategicas();
            this.CargarCargosPersonal();
            this.CargarGeneros();
            this.CargarNacionalidades();

            if(this.persona_id){
                this.CargarProfesorJornadaParcial();
                this.CargarEstados();
            }
        },
        methods: {
            BuscarProfesorJornadaParcial() {
                let self = this;

                // Cargamos URL
                axios.get('/administrador/profesores-jornada-parcial/buscar/' + self.form.rut)
                    .then(response => {
                        if(response.data.code == 1){
                            self.profesor = response.data.persona;
                            self.cargo = response.data.cargo;
                            console.log(response.data);

                            if (response.data.msg) {
                                self.msg = response.data.msg;
                            }

                            self.CargarFormulario();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarAreasEstrategicas() {
                let self = this;

                // Cargamos URL
                axios.get('/data/areas-estrategicas')
                    .then(response => {
                        self.form_data.areas_estrategicas = response.data.areas_estrategicas;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarCargosPersonal() {
                let self = this;

                // Cargamos URL
                axios.get('/data/cargos-personal')
                    .then(response => {
                        self.form_data.cargos_personal = response.data.cargos_personal;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarEstados() {
                const self = this;

                // Cargamos URL
                axios.get('/data/estados')
                    .then(response => {
                        self.form_data.estados = response.data.estados;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarFormulario() {
                this.form.rut = this.profesor.rut;
                this.form.nombres = this.profesor.nombres;
                this.form.apellido_paterno = this.profesor.apellido_paterno;
                this.form.apellido_materno = this.profesor.apellido_materno;
                this.form.fecha_nacimiento = this.profesor.fecha_nacimiento;
                this.form.nacionalidad_id = this.profesor.nacionalidad_id;
                this.form.genero_id = this.profesor.genero_id;

                if (this.cargo) {
                    this.form.cargo_personal_id = this.cargo.cargo_personal_id;
                    this.form.area_estrategica_id = this.cargo.area_estrategica_id;
                    this.form.fecha_incorporacion = this.cargo.fecha_incorporacion;
                    this.form.fecha_salida = this.cargo.fecha_salida;
                    this.form.observaciones = this.cargo.observaciones;
                    this.form.estado_id = this.cargo.estado_id;
                }
            },
            CargarGeneros() {
                let self = this;

                // Cargamos URL
                axios.get('/data/generos')
                    .then(response => {
                        self.form_data.generos = response.data.generos;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarNacionalidades() {
                let self = this;

                // Cargamos URL
                axios.get('/data/nacionalidades')
                    .then(response => {
                        self.form_data.nacionalidades = response.data.nacionalidades;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarProfesorJornadaParcial() {
                let self = this;

                // Cargamos URL
                axios.get('/administrador/profesores-jornada-parcial/' + self.persona_id)
                    .then(response => {
                        if(response.data.code == 1){
                            self.profesor = response.data.persona;
                            self.cargo = response.data.cargo;

                            self.CargarFormulario();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            onSubmit() {
                let self = this;

                self.cargando = true;

                let url = '/administrador/profesores-jornada-parcial';
                if(self.persona_id){
                    url = url + '/' + self.persona_id;
                    self.form._method = "PATCH";
                }

                this.form.post(url)
                    .then(function(response){
                        if(response.data.code == 1){
                        	window.location.href = response.data.redirect;
                        }
                        else{
                            window.Event.$emit('notificacion', 'error', response.data.msg);
                        }
                    })
                    .catch(function (error) {
                    	if(error.response.status == 422){
	            			window.Event.$emit('errores', error);
		            	}
		            	else{
                            window.Event.$emit('notificacion', 'error', 'Se ha producido un error al registrar el profesor de jornada parcial');
		            		console.log(error.response.data);
		            	}
                    })
                    .then(function(){
                        self.cargando = false;
                    });
            }
        }
    }
</script>
